import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import NextImage from "next/image"; // 保留这个给用户头像和奖励按钮
import Image from "next/image";
import { useRouter } from "nextjs-toploader/app";
import { useCallback, useRef } from "react"; // 导入 useRef 和 useCallback
import { useTranslation } from "react-i18next";
import DefaultAvatar from "@/assets/images/account/default-avatar.png";
import AccountAddressIcon from "@/assets/svg/account-address-icon.svg";
import AccountOrderIcon from "@/assets/svg/account-order-icon.svg";
import ChevronLeftEmpty from "@/assets/svg/chevron-left-empty.svg";
import AccountRewardIcon from "@/assets/svg/rewards-icon.svg"; // 假设奖励对应 shop 图标
import Time1Icon from "@/assets/svg/time1.svg";
import Time2Icon from "@/assets/svg/time2.svg";
import { Separator } from "@/components/ui/separator";
import { useIsMobile } from "@/hooks/use-mobile";
import LocaleLink from "@/lib/i18n/locale-link";
import { cn } from "@/lib/utils";
import { OrderStatusEnum } from "@/modules/order/schema";
import OrderMenuChevronUpIcon from "@/modules/users/assets/order-menu-chevron-up.svg";
// import OrderOnlineIcon from "@/modules/users/assets/order-online.svg"
import { useAuth } from "@/providers/auth-provider";
import { useORPC } from "@/providers/orpc-provider";
interface UserAccountSidebarProps {
  activeModule: string;
  setActiveModule: (module: string) => void;
  isMobile?: boolean;
}

// 定义新的 SidebarMenuItemProps 接口
interface SidebarMenuItemProps {
  // iconSrc: string; // 旧的属性
  IconComponent: React.FC<React.SVGProps<SVGSVGElement>>; // 新属性：接受 SVG 组件
  title: string;
  subtitle: string;
  moduleName: string;
  activeModule: string;
  onClick: (e: React.MouseEvent) => void;
  isMobile?: boolean;
}
function SidebarMenuItem(t0) {
  const $ = _c(29);
  const {
    IconComponent,
    title,
    subtitle,
    moduleName,
    activeModule,
    onClick,
    isMobile: t1
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  const isActive = activeModule === moduleName;
  const t2 = isMobile ? "h-15 p-3 hover:bg-gray-50" : "h-18.5 p-4";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("hover:text-destructive flex items-center justify-between transition-colors", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = !isMobile && isActive && "text-destructive";
  let t5;
  if ($[2] !== t4) {
    t5 = cn("flex items-center", t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = isMobile ? 20 : 24;
  const t7 = isMobile ? 20 : 24;
  let t8;
  if ($[4] !== IconComponent || $[5] !== t6 || $[6] !== t7) {
    t8 = <IconComponent className="mr-2 size-5 text-current md:size-6" width={t6} height={t7} />;
    $[4] = IconComponent;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== title) {
    t9 = <div className="font-['DINPro-Medium'] text-sm font-medium md:font-['DINPro-Bold'] md:font-bold md:text-base">{title}</div>;
    $[8] = title;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== isMobile || $[11] !== subtitle) {
    t10 = !isMobile && <div className="font-['DINPro-Regular'] text-sm font-normal">{subtitle}</div>;
    $[10] = isMobile;
    $[11] = subtitle;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <div>{t9}{t10}</div>;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t5 || $[18] !== t8) {
    t12 = <div className={t5}>{t8}{t11}</div>;
    $[16] = t11;
    $[17] = t5;
    $[18] = t8;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = !isMobile && isActive ? "text-destructive" : "";
  let t14;
  if ($[20] !== t13) {
    t14 = cn("h-5 w-5 rotate-180 text-[#989898]", t13);
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t14) {
    t15 = <ChevronLeftEmpty className={t14} />;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== onClick || $[25] !== t12 || $[26] !== t15 || $[27] !== t3) {
    t16 = <a href="#" onClick={onClick} className={t3}>{t12}{t15}</a>;
    $[24] = onClick;
    $[25] = t12;
    $[26] = t15;
    $[27] = t3;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  return t16;
}

// 新增订单类型项组件
interface OrderMenuItemProps {
  IconComponent: React.FC<React.SVGProps<SVGSVGElement>>;
  label: string;
  isActive?: boolean;
  hasItems?: boolean;
  onClick?: () => void; // 添加点击处理
}
function _OrderMenuItem({
  IconComponent,
  label,
  isActive = false,
  hasItems = false,
  onClick // 接收点击处理
}: OrderMenuItemProps) {
  const isMobile = useIsMobile();
  return <div className="flex cursor-pointer flex-col items-center" onClick={onClick}>
			<IconComponent className="size-8.5" />
			<span className={cn("text-center text-xs leading-3 tracking-tight whitespace-nowrap text-[#111111] uppercase md:text-sm", isActive && !isMobile ? "text-destructive font-medium" : " ")}>
				{label}
			</span>
			{hasItems && <span className="mt-3 h-2.25 translate-y-px border-b border-[#FCFCFC] bg-[#FCFCFC]">
					<OrderMenuChevronUpIcon className="h-2.25 w-6" />
				</span>}
		</div>;
}
export function UserAccountSidebar({
  activeModule,
  setActiveModule,
  isMobile = false
}: UserAccountSidebarProps) {
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const sidebarRef = useRef<HTMLDivElement | null>(null); // 创建 ref
  const orpc = useORPC();
  const auth = useAuth(); // 使用新的 auth hook
  const {
    data: userProfile
  } = useQuery(orpc.user.getProfile.queryOptions());
  const {
    data: currentPointsData
  } = useQuery({
    ...orpc.member.getCurrentPoints.queryOptions({
      input: {}
    })
  });
  const {
    data: userCouponCounts
  } = useQuery(orpc.ec.userCoupon.findMyCouponCounts.queryOptions({
    input: {}
  }));
  const username = userProfile?.name || t("common.user", "用户");
  const userAvatar = userProfile?.avatar || DefaultAvatar;
  const handleLogout = async () => {
    try {
      // 优先使用 auth provider 的方法
      if (auth?.logout) {
        await auth.logout({
          redirectUrl: "/",
          clearQueryCache: true,
          showToast: false
        });
      } else {
        // 最后备用：直接跳转
        console.warn("No logout method available, redirecting directly");
        router.push("/");
      }
    } catch (error) {
      console.error("退出登录失败:", error);
      // 备用处理：直接跳转
      router.push("/");
    }
  };

  // 创建一个处理菜单项点击的函数
  const handleMenuClick = useCallback((module: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    setActiveModule(module);
    if (sidebarRef.current) {
      sidebarRef.current.scrollTop = 0; // 重置滚动条
    }
  }, [setActiveModule]);
  return <div ref={sidebarRef} className={cn(isMobile ? "min-h-screen bg-white p-4" : "bg-[#f5f5f5]")}>
			{/* 附加 ref */}
			{/* 用户信息头部 - Section 1 */}
			{isMobile ?
    // 移动端：左右布局
    <div className="mb-6 flex items-center justify-between">
					{/* 左侧内容区 */}
					<div className="flex items-center">
						{/* 头像 */}
						<div className="mr-3 rounded-full border border-[#ddd]">
							<Image src={userAvatar} alt={t("account.sidebar.avatarAlt", "用户头像")} width={46} height={46} className="aspect-square size-15 rounded-full object-cover" />
						</div>
						{/* 用户名和链接 */}
						<div className="flex flex-col">
							<h2 className="mb-2 font-['DINPro-Bold'] text-base leading-none font-bold text-black">
								{username}
							</h2>
							<div className="flex gap-2 text-xs text-[#666] md:text-sm">
								<LocaleLink href="/account/manage" className={cn("hover:text-destructive cursor-pointer underline", activeModule === "profile" && "text-destructive font-medium")}>
									{t("account.sidebar.editProfile", "編輯個人資料")}
								</LocaleLink>
								<LocaleLink href="/account/setting" className={cn("hover:text-destructive cursor-pointer underline", activeModule === "settings" && "text-destructive font-medium")}>
									{t("account.settings.title", "帳戶設置")}
								</LocaleLink>
							</div>
						</div>
					</div>
					{/* 右侧退出按钮 */}
					<button type="button" onClick={handleLogout} className="no-italic cursor-pointer text-left font-['DINPro-Regular'] text-xs leading-3.5 font-normal text-[#555] underline md:text-sm">
						{t("common.button.logout", "登出")}
					</button>
				</div> : (/*  */
    // 桌面端：原有布局
    <>
					<div className="flex justify-end">
						<button type="button" onClick={handleLogout} className="no-italic mt-4 mr-4 cursor-pointer text-left font-['DINPro-Regular'] text-[0.875rem] leading-3.5 font-normal text-[#666] underline">
							{t("common.button.logout", "登出")}
						</button>
					</div>
					<div className="flex flex-col items-center px-4">
						<div className="mb-2 rounded-full border border-[#ddd]">
							<Image src={userAvatar} alt={t("account.sidebar.avatarAlt", "用户头像")} width={46} height={46} className="aspect-square rounded-full object-cover" />
						</div>
						<h2 className="mb-2 text-center font-['DINPro-Bold'] text-[1rem] leading-4.25 font-bold text-black">
							{username}
						</h2>
						<div className="mt-1 flex gap-3 text-sm text-[#666]">
							<LocaleLink href="/account/manage" className={cn("hover:text-destructive flex cursor-pointer flex-col items-center justify-center text-nowrap underline", activeModule === "profile" && "text-destructive font-medium")}>
								{t("account.sidebar.editProfile", "編輯個人資料")}
							</LocaleLink>
							<LocaleLink href="/account/setting" className={cn("hover:text-destructive flex cursor-pointer flex-col items-center justify-center text-nowrap underline", activeModule === "settings" && "text-destructive font-medium")}>
								{t("account.settings.title", "帳戶設置")}
							</LocaleLink>
						</div>
					</div>
					<Separator className="my-8" />
				</>)}

			{/* 会员信息 - Section 2 */}
			<div className={cn(isMobile ? "mb-6 rounded-lg bg-[hsla(40,54%,92%,.5)] p-4" : "px-4")}>
				<div className="text-center">
					<h3 className="text-left font-['DINPro-Medium'] text-xs font-medium text-black md:font-['DINPro-Bold'] md:text-sm md:font-bold">
						POPMART MEMBER
					</h3>
				</div>

				<div className="mt-8 flex">
					<div className="flex-1 border-r border-gray-200 text-center">
						<a href="#" onClick={handleMenuClick("points")} className={cn("hover:text-destructive block", !isMobile && activeModule === "points" ? "text-destructive" : "text-black")}>
							<div className="mb-1.5 text-center font-['DINPro-Bold'] text-[1.375rem] leading-5.5 font-bold">
								{currentPointsData?.points || 0}
							</div>
							<div className="text-center font-['DINPro-Regular'] text-[0.875rem] leading-[1rem] font-normal">
								{t("account.sidebar.points", "積分")}
							</div>
						</a>
					</div>
					<div className="flex-1 text-center">
						<a href="#" onClick={handleMenuClick("coupons")} className={cn("hover:text-destructive block", !isMobile && activeModule === "coupons" ? "text-destructive" : "text-black")}>
							<div className="mb-1.5 text-center font-['DINPro-Bold'] text-[1.375rem] leading-5.5 font-bold">
								{userCouponCounts?.availableCount || 0}
							</div>
							<div className="text-center font-['DINPro-Regular'] text-[0.875rem] leading-[1rem] font-normal">
								{t("account.sidebar.coupons", "優惠券")}
							</div>
						</a>
					</div>
				</div>

				<div className="mt-4">
					<a href="#">
						<button className="mt-4 flex h-10 w-full cursor-pointer items-center justify-center bg-white text-right font-['DINPro-Medium'] text-sm font-normal text-[#988066]" type="button" onClick={handleMenuClick("exchange")}>
							<AccountRewardIcon className="size-5" />
							<span className="ml-2">
								{t("account.sidebar.rewards", "獎勵")}
							</span>
						</button>
					</a>
				</div>
			</div>

			{!isMobile && <Separator className="mt-8 mb-0" />}

			{/* <UserAccountSidebarOrderMenu activeModule={activeModule} setActiveModule={setActiveModule} /> */}

			{/* 导航菜单 - Section 3 */}
			<div className={cn(isMobile ? "border-t border-b border-gray-200" : "", "p-l-4")}>
				{/* Use the new SidebarMenuItem component */}
				<SidebarMenuItem
      // iconSrc="/images/address-icon.png" // 旧的属性
      IconComponent={AccountOrderIcon} // 传递 SVG 组件
      title={t("account.sidebar.menu.orders.title", "My Orders")} subtitle={t("account.sidebar.menu.orders.subtitle", "Manage your orders")} moduleName="orders" activeModule={activeModule} onClick={handleMenuClick("orders")} isMobile={isMobile} />
				<Separator />
				<SidebarMenuItem
      // iconSrc="/images/address-icon.png" // 旧的属性
      IconComponent={AccountAddressIcon} // 传递 SVG 组件
      title={t("account.addresses.title", "地址簿")} subtitle={t("account.sidebar.menu.addresses.subtitle", "管理訂單地址")} moduleName="addresses" activeModule={activeModule} onClick={handleMenuClick("addresses")} isMobile={isMobile} />
				<Separator />
				<SidebarMenuItem
      // iconSrc="/images/reward-icon.png" // 旧的属性
      IconComponent={AccountRewardIcon} // 传递 SVG 组件 (假设是这个)
      title={t("account.rewards.title", "賺取的獎勵")} subtitle={t("account.sidebar.menu.rewards.subtitle", "管理賺取的獎勵")} moduleName="rewards" activeModule={activeModule} onClick={handleMenuClick("rewards")} isMobile={isMobile} />
				<Separator />
				<SidebarMenuItem IconComponent={activeModule === "registrations" ? Time2Icon : Time1Icon} title={t("account.registrations.title", "我的預約")} subtitle={t("account.sidebar.menu.registrations.subtitle", "管理我的預約")} moduleName="registrations" activeModule={activeModule} onClick={handleMenuClick("registrations")} isMobile={isMobile} />
			</div>
		</div>;
}
function _UserAccountSidebarOrderMenu({
  setActiveModule
}: {
  activeModule: string;
  setActiveModule: (module: string) => void;
}) {
  const {
    t
  } = useTranslation();
  const orpc = useORPC();

  // 查询待发货的门店取货订单
  const {
    data: waitSendOrders
  } = useQuery({
    ...orpc.storePick.storePickOrder.getUserOrders.queryOptions({
      input: {
        page: 1,
        pageSize: 1,
        status: [OrderStatusEnum.SENDED]
      }
    })
  });
  const waitSendCount = waitSendOrders?.total || 0;
  const mainImage = waitSendOrders?.items?.[0]?.items?.[0]?.sku?.mainImage || "/placeholder-product-image.png";
  return <div className={cn("flex flex-col bg-[#f9f9f9]/50 p-3 md:p-4", waitSendCount > 0 ? "mb-4" : " ")}>
			<span className="text-px12 md:text-px16 text-left leading-none font-bold whitespace-nowrap text-black">
				MY&nbsp;ORDER
			</span>
			<div>
				<div className={cn("relative mt-4 flex flex-row justify-around", waitSendCount > 0 ? "border-b" : " ")}>
					{/* <OrderMenuItem
            IconComponent={OrderOnlineIcon}
            label="POP ONLINE"
            isActive={activeModule === "orders"}
            onClick={() => setActiveModule("orders")}
          />
          <OrderMenuItem
            IconComponent={OrderStoreGoIcon}
            label="POP PICKUP"
            hasItems={true && waitSendCount > 0}
            isActive={activeModule === "orders-store-go"}
            onClick={() => setActiveModule("orders-store-go")}
          /> */}
				</div>
			</div>
			{waitSendCount > 0 && <div className="mt-3 flex w-full flex-row gap-2">
					<div className="flex items-center justify-center">
						<NextImage src={mainImage} alt="POP PICKUP" className="size-13.5 bg-[#ededed] object-contain" width={80} height={80} />
					</div>
					<div className="flex flex-1 flex-col items-stretch justify-center gap-2.5">
						<div className="flex flex-row items-center justify-between">
							<span className="text-px12 leading-3 whitespace-nowrap text-[#111111]">
								{t("account.sidebar.orders.pickup", {
              count: waitSendCount
            })}
							</span>
							<button className="text-px10 h-6.25 w-17.5 bg-black font-medium text-white uppercase" type="button" onClick={() => setActiveModule("orders-store-go")}>
								{t("account.sidebar.orders.pickup.button")}
							</button>
						</div>
						<span className="text-px11 leading-3 whitespace-nowrap text-[#999999]">
							{t("account.sidebar.orders.pickup.subtitle")}
						</span>
					</div>
				</div>}
		</div>;
}